module.exports = __webpack_public_path__ + "img/dew_point.f837a03f.svg";